import useProgressBarActions from '@/composables/progress/useProgressBarActions';
import { trackStatusViewed } from '@/composables/tracking/useDataDogTracking';

const { updateToComplete, resetAllProgress } = useProgressBarActions();

const routes = [
  {
    path: '/nft',
    name: 'nft.order',
    component: () => import('@/views/nft/NFTOrderView.vue'),
    beforeEnter() {
      resetAllProgress();
    },
  },
  {
    path: '/nft/transit',
    name: 'nft.order.transit',
    component: () => import('@/views/nft/NFTOrderView.vue'),
    beforeEnter() {
      resetAllProgress();
    },
  },
  {
    path: '/nft/status/:orderId',
    name: 'nft.summary',
    component: () => import('@/views/nft/NftSummaryView.vue'),
    beforeEnter() {
      updateToComplete(['verification', 'identity', 'payment']);
      trackStatusViewed({ nft: true });
    },
  },
];

export default routes;
